function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("title", null, "\uE604");

var _ref3 =
/*#__PURE__*/
React.createElement("desc", null, "Created with Sketch.");

var _ref4 =
/*#__PURE__*/
React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd",
  fontFamily: "simple-line-icons",
  fontSize: 12,
  fontWeight: "normal"
}, React.createElement("g", {
  id: "Product-Detail-Page---Desc",
  transform: "translate(-1046.000000, -129.000000)",
  fill: "#000000"
}, React.createElement("g", {
  id: "Category-Bar",
  transform: "translate(0.000000, 95.000000)"
}, React.createElement("g", {
  id: "Search-Bar",
  transform: "translate(932.000000, 16.000000)"
}, React.createElement("text", {
  id: "\\uE604"
}, React.createElement("tspan", {
  x: 114,
  y: 27
}, "\uE604"))))));

var SvgDownArrowBlack = function SvgDownArrowBlack(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: "12px",
    height: "7px",
    viewBox: "0 0 12 7",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgDownArrowBlack, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/downArrowBlack.c1b9e59b.svg";
export { ForwardRef as ReactComponent };